"use strict";

define('model/sp.proposal',['backbone', './base', '../libs/cf.convert'], function (Backbone, BaseModel, CFConvert) {
  var CAYUSE_PERSON_FIELD = 'legacyCayuseId';
  var CAYUSE_URL = '/sp/de_general_info.cfm';
  var SPProposal = BaseModel.extend({
    idAttribute: 'PROPOSALID',
    virtual: {
      'link': function link() {
        return CAYUSE_URL + '?' + $.param({
          prop_id: this.id
        });
      },
      'LEADFULLNAME': {
        deps: ['LEADFNAME', 'LEADLNAME'],
        get: function get() {
          return this.get('LEADFNAME') + ' ' + this.get('LEADLNAME');
        }
      }
    },
    collectionParse: function collectionParse(resp) {
      return resp;
    }
  }, {
    all: function all(people) {
      var collection = this.createCollection('/sp/model/cayuse/cayuseIntegration.cfc').addAdapter({
        preprocess: function preprocess(options) {
          var personIds = _.compact(people.pluck(CAYUSE_PERSON_FIELD));
          var params = {
              pids: _.map(personIds, function (personId) {
                return String(personId);
              })
            },
            data = {
              method: 'ExecIntegrationMethod',
              theMethod: 'getProposalsByPid',
              theParams: JSON.stringify(params)
            };
          options.data = data;
          options.jsonp = 'callback';
          return;
        },
        filter: function filter(resp) {
          return CFConvert.convertResponse(resp);
        },
        postprocess: function postprocess(resp) {
          resp.error = resp.USERMSG;
        }
      });
      if (!(people instanceof Backbone.Collection)) {
        throw new Error('Must use an instance of Backbone.Collection');
      }
      return collection;
    }
  });
  return SPProposal;
});

